export default __webpack_public_path__ + "stat-leaders.2b55bd58.svg";